function parseLeaveDateParts(value) {
  if (value == null || value === '') return null;
  const raw = String(value).trim();
  if (!raw) return null;

  if (/^\d{2}\/\d{2}\/\d{4}$/.test(raw)) {
    const [day, month, year] = raw.split('/').map(Number);
    return { year, month, day };
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
    const [year, month, day] = raw.split('-').map(Number);
    return { year, month, day };
  }

  const parsed = new Date(raw);
  if (Number.isNaN(parsed.getTime())) return null;
  return {
    year: parsed.getFullYear(),
    month: parsed.getMonth() + 1,
    day: parsed.getDate(),
  };
}

export function leaveDateToInputValue(value) {
  const parts = parseLeaveDateParts(value);
  if (!parts) return '';
  const month = String(parts.month).padStart(2, '0');
  const day = String(parts.day).padStart(2, '0');
  return `${parts.year}-${month}-${day}`;
}

export function buildLeaveFormFromRecord(leave, defaults = {}) {
  const start = leaveDateToInputValue(leave?.start_date);
  const end = leaveDateToInputValue(leave?.end_date || leave?.start_date);
  const isMultiple = Boolean(start && end && start !== end);

  return {
    leave_duration: isMultiple ? 'multiple' : 'single',
    start_date: start,
    end_date: isMultiple ? end : '',
    leave_type: leave?.leave_type || defaults.leave_type || '',
    day_type: leave?.day_type || defaults.day_type || '',
    description: leave?.description || '',
  };
}
